<template>
  <div>
    <div class="authwrapper absolute-center">
      <div class="row">
        <div class="col-12 q-pb-lg"><img src="./../../assets/logo.svg" alt="" srcset="" /></div>
      </div>
      <div class="card-block auth-card">
        <transition name="fade" mode="out-in">
          <Login v-if="$route.name === 'login'"></Login>
          <Reset v-if="$route.name === 'reset'"></Reset>
          <InputResetPassword v-if="$route.name === 'inputResetPassword'"></InputResetPassword>
          <Accept v-if="$route.name === 'accept'"></Accept>
        </transition>
      </div>
      <div class="row" v-if="$route.name === 'login'">
        <div class="col-12 q-pt-md">
          <div class="passwordresetlink text-center">
            <a @click="$router.push('reset');">
              {{ getString('login.toReset') }}
            </a>
          </div>
        </div>
      </div>
      <div class="row" v-if="$route.name === 'reset'">
        <div class="col-12 q-pt-md">
          <div class="passwordresetlink text-center">
            <a @click="$router.push('login');">
              {{ getString('requestReset.toLogin') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getString from '@/helpers/GetStrings';
import Login from './Login.vue';
import Reset from './Reset.vue';
import InputResetPassword from './InputResetPassword.vue';
import Accept from './Accept.vue';

export default {
  methods: {
    getString,
  },
  name: 'AuthWrapper',
  components: {
    Login,
    Reset,
    InputResetPassword,
    Accept,
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
.auth-card
    max-height: 60vh;
    overflow: hidden;
    overflow-y: scroll;
form
    width 100%
.passwordresetlink
    a
        display block
        padding .8rem 0
        font-size 75%
        color #929aad
        text-shadow rgba(0,0,0,.3) 0 1px 0
        cursor pointer
        transition color .3s ease-out
        &:hover
            color: $ctrl-grey-lighten-2
.authwrapper
    width 100%
    max-width 22rem
    img
        display block
        width 35%
        margin 0 auto
.card-block
    border none !important
    padding 1rem .5rem 1rem
</style>
